import {
  AlertTitle,
  Placeholder,
} from "Components/TextContext/commonComponentEnums";
import {
  FindVehicleModelsEntity,
  Model,
  VehicleModelConfiguration,
} from "Store/findVehicleType/interfaces";
import { addDefaultSelectOption, setField } from "Utils/formUtils";

import { Option } from "@storeblocks/select";
import { TextManager } from "Components/TextContext";
import { getPhoneNumberTextConfig } from "Components/TextContext/textUtils";
import { MotorcycleProductIntroFormValues } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Motorcycle/motorcycleInterface";
import { VEHICLE_TYPE } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/vehicleConstants";
import { FormikProps } from "formik";
import { CarProductIntroFormValues } from "../interfaces";
import { FindVehicleTypeTexts } from "./findVehicleTypeInterface";

export const namedValueToOption = ({ name }: { name: string }): Option => ({
  label: name,
  value: name,
});

export const modelTypeOptions = (
  vehicleType: VEHICLE_TYPE,
  placeholder: string,
  models: FindVehicleModelsEntity,
  formProps: FormikProps<
    CarProductIntroFormValues | MotorcycleProductIntroFormValues
  >,
): Option[] =>
  vehicleType === VEHICLE_TYPE.CAR
    ? addDefaultSelectOption(
        placeholder,
        getModelTypeOptions(models.current, formProps.values.model) ?? [],
      )
    : [];

export const handleVehicleModelTypeChange = (
  event: React.ChangeEvent<HTMLSelectElement>,
  models: Model[] | null,
  formProps: FormikProps<CarProductIntroFormValues>,
): void => {
  const configuration = findModelConfigurationsByName(
    models,
    formProps.values.model,
    event.target.value,
  );

  if (!configuration) {
    return;
  }

  setField(formProps, "configurationId", configuration.configurationId);
  setField(formProps, "kw", configuration.kw);
  setField(formProps, "volume", configuration.volume);
  setField(formProps, "canBeBoughtOnline", configuration.canBeBoughtOnline);
  setField(formProps, "tfaCode", configuration.tfaCode);
  setField(formProps, "modelTypeName", configuration.displayName);
};

const findModelConfigurationsByName = (
  models: Model[] | null,
  modelName: string | undefined,
  configurationId: string,
): VehicleModelConfiguration | undefined => {
  const selectedModel = models?.find(({ name }) => name === modelName);
  if (selectedModel) {
    return selectedModel.configurations.find(
      (config) => config.configurationId === Number(configurationId),
    );
  }
  return undefined;
};

const configurationToOption = (
  configuration: VehicleModelConfiguration,
): Option => ({
  label: configuration.displayName,
  value: configuration.configurationId.toString(),
});

export const getModelTypeOptions = (
  models: Model[] | null,
  modelName: string | undefined,
): Option[] | undefined =>
  models
    ?.find((model) => model.name === modelName)
    ?.configurations.map(configurationToOption);

const { createLinkComponent, getText } = TextManager;

export const findVehicleTextsCar: FindVehicleTypeTexts = {
  yearPlaceholder: getText(Placeholder.CHOOSE_YEAR),
  yearLabel: getText("carform.label.firstregistered"),
  brandPlaceholder: getText("carform.placeholder.brand"),
  brandLabel: getText("carform.label.brand"),
  brandSearchErrorAlertTitle: getText(AlertTitle.CALL_US),
  brandSearchErrorAlertDescription: getText(
    "carform.alertdescription.brand-cant_buy_online",
  ),
  modelPlaceholder: getText("carform.placeholder.model"),
  modelLabel: getText("carform.label.model"),
  brandNotPresentAlertTitle: createLinkComponent(
    "carform.alerttitle.brand",
    getPhoneNumberTextConfig(),
    false,
  ),
  modelTypePlaceholder: getText("carform.placeholder.modeltype"),
};

export const findVehicleTextsMotorcycle: FindVehicleTypeTexts = {
  yearPlaceholder: getText(Placeholder.CHOOSE_YEAR),
  yearLabel: getText("motorcycleform.label.firstregistered"),
  brandPlaceholder: getText("motorcycleform.placeholder.brand"),
  brandLabel: getText("motorcycleform.label.brand"),
  brandSearchErrorAlertTitle: getText(AlertTitle.CALL_US),
  brandSearchErrorAlertDescription: getText(
    "motorcycleform.alertdescription.brand-cant_buy_online",
  ),
  modelPlaceholder: getText("motorcycleform.placeholder.model"),
  modelLabel: getText("motorcycleform.label.model"),
  brandNotPresentAlertTitle: createLinkComponent(
    "motorcycleform.alerttitle.brand",
    getPhoneNumberTextConfig(),
    false,
  ),
};
